export const handleAggregatorResponse = (response) => () => {
    if (response.status < 300) {
        return Promise.resolve(response.body);
    }
    return Promise.reject(response);
};
export const handleAggregatorResponseWithHeaders = (response) => () => {
    if (response.status < 300) {
        return Promise.resolve({
            body: response.body,
            headers: new Headers(response.headers),
        });
    }
    return Promise.reject(response);
};
//# sourceMappingURL=aggregator.js.map